// extracted by mini-css-extract-plugin
export var container = "_8r-0";
export var error = "_8r-9";
export var label = "_8r-5";
export var light = "_8r-6";
export var md = "_8r-3";
export var sm = "_8r-2";
export var thin = "_8r-8";
export var thinBold = "_8r-7";
export var vertical = "_8r-4";
export var xs = "_8r-1";